// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 962 ? "QQShare" : chunkId) + "." + {"388":"d69989a112","962":"844a2f095b"}[chunkId] + ".js";
};